import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { Translates } from '../../ph-simple-table/translates';
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';

import { SHARED_MODULES } from '../../../../shared.';
import { SanitizerPipe } from '../../../pipes/sanitizer.pipe';
import { PhTooltipDirective } from '../../../directives/ph-tooltip.directive';

export const ELEMENT = new InjectionToken<string>('element', {
    providedIn: 'root',
    factory: () => 'element'
});

type TooltipDtypeElement = {
    value: string | number;
    title?: string;
    image?: string;
    disabled?: boolean;
};

@Component({
    selector: 'app-tooltip-dtype',
    templateUrl: 'tooltip-dtype.component.html',
    styleUrls: ['tooltip-dtype.component.scss'],
	imports: [SHARED_MODULES, SanitizerPipe, PhTooltipDirective],
    standalone: true
})
export class TooltipDtypeComponent implements OnInit {

    element: TooltipDtypeElement;
    translates = Translates;

    constructor(@Inject(ELEMENT) private elementInjected: IInjectedElementDtype<TooltipDtypeElement>) {}

    ngOnInit(): void {
        this.element = this.elementInjected.element;
    }
}
